import { PROMOTION_STATIC_QUERY_SUGGESTION_COPY } from "@mirage/mosaics/Chat/components/chat/instructions/bridge_growth/constants";
import { PromotionSuggestionChip } from "@mirage/mosaics/Chat/components/chat/instructions/bridge_growth/PromotionSuggestionChip";
import { PromotionWriteWithTemplateChip } from "@mirage/mosaics/Chat/components/chat/instructions/bridge_growth/PromotionWriteWithTemplateChip";
import { useChatRoute } from "@mirage/mosaics/ConversationAssistant/hooks/useChatRoute";
import { useQuerySuggestions } from "@mirage/mosaics/QuerySuggestions/useQuerySuggestions";
import type { FssAskFromSuggestionParams } from "@mirage/service-conversation/router_state_types";
import { CtaSource } from "@mirage/service-conversation/router_state_types";
import { buildConversationRouterState } from "@mirage/service-conversation/utils/buildConversationRouterState";
import { useNavigate } from "react-router-dom";
import styles from "../EmptyChatInstructions.module.css";

export const PromotionQuerySuggestionContainer = () => {
  const navigate = useNavigate();
  const chatRoute = useChatRoute();

  const handleClick = (query: string) => {
    const askConversationParams: FssAskFromSuggestionParams = {
      message: query,
      chatSources: [],
      agentIds: [],
      scenarioMeta: {
        type: "other",
      },
    };
    const routerState = buildConversationRouterState(
      CtaSource.FssAskFromSuggestion,
      askConversationParams,
    );
    navigate(chatRoute, { state: routerState });
  };

  //TODO (DISCOVERY-7369): use fileIDs from userMessageOptions
  const { isLoading, querySuggestions } = useQuerySuggestions({
    maxSuggestions: 1,
    demoSuggestions: [],
    options: { source: "dash", retriever: "fss", documentIds: [] },
  });

  return (
    <div className={styles.SuggestionTiles}>
      {/* TODO (DISCOVERY-7304): update the copies to use non-placeholder values} */}
      <PromotionSuggestionChip
        text={PROMOTION_STATIC_QUERY_SUGGESTION_COPY}
        onSubmit={() => {
          handleClick(PROMOTION_STATIC_QUERY_SUGGESTION_COPY);
        }}
      />
      {querySuggestions.length && (
        <PromotionSuggestionChip
          {...querySuggestions[0]}
          isLoading={isLoading}
          onSubmit={() => {
            handleClick(querySuggestions[0]?.text);
          }}
        />
      )}
      <PromotionWriteWithTemplateChip />
    </div>
  );
};

PromotionQuerySuggestionContainer.displayName =
  "PromotionQuerySuggestionContainer";
